import React, { useEffect, useMemo, useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  OffCanvas,
  SaveButton,
  Table,
  cpfCnpjFormat,
  useMessageDispatch,
} from 'itaf';

import CustomerService from '../../../services/CustomerService';

export default function CustomerCanvas(props) {
  const [tableRef, setTableRef] = useState();

  const [customers, setCustomers] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [isSaving, setSaving] = useState(false);
  const [selected, setSelected] = useState({});
  // const [hasSelected, setHasSelected] = useState(false);

  const setMessageLocal = useMessageDispatch();
  function setMessage(message) {
    if ('parentIFrame' in window) {
      window.parentIFrame.sendMessage(message);
    }
  
    setMessageLocal(message);
  }
  
  useEffect(() => {
    if (props.open) {
      setCustomers(props.dados);
      setLoading(true);
      
      const id = props.user.id;
      
      CustomerService.getCustomersByUserId(id)
        .then(response => response.json())
        .then((result) => {
          const sel = {};
          result.forEach((item) => { sel[`${item.customerId}`] = true });
          setSelected(sel);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [props.open]);

  useEffect(() => {
    if (selected && tableRef) {
      tableRef.setRowSelection(selected);
    }
  }, [tableRef, selected]);

  const handleOnRegister = () => {
    setSaving(true);
    
    const save = {
      userId: props.user.id,
      customers: Object.keys(tableRef?.getState().rowSelection),
    };

    CustomerService.postCustomerUser(save)
      .then((response) => {
        if (response.ok) {
          props.onChange();
        }
        else {
          setMessage({ hasError: true, text: `Problema ao salvar clientes para o usuário ${props.user.name}` });
        }
      })
      .catch (() => {
        setMessage({ hasError: true, text: `Problema ao salvar clientes para o usuário ${props.user.name}` });
      })
      .finally (() => {
        setSaving(false);
      });
  }
  
  const buttons = (
    <SaveButton
      loading={isSaving}
      // disabled={!hasSelected}
      onClick={handleOnRegister}
      size="medium"
      sx={(theme) => ({ marginLeft: theme.spacing(2) })}
    >
      {/* {hasSelected && isLoading ? 'Salvando' : 'Salvar'} */}
      {isSaving ? 'Salvando' : 'Salvar'}
    </SaveButton>
  );

  const handleDrawerClose = () => {
    // setTimeout(() => { setMessage({ hasError: false, text: '' }); }, 10000);
    props.onCanvasClose(false);
  };

  const columns = useMemo(
    () => [
      {
        header: "CNPJ/CPF", accessorKey: "cnpj", minSize: 70, size: 80,
        enableHiding: false, enableColumnActions: false,
        Cell: ({ renderedCellValue, row }) => (cpfCnpjFormat(renderedCellValue)),
      },
      {
        header: "Nome", accessorKey: "nome", //size: 480,
        enableHiding: false, enableColumnActions: false,
      },
    ],
    []
  );

  const buildTable = () => {
    return <Table
      title='Clientes'
      columns={columns}
      data={customers}
      setTableRef={setTableRef}
      isLoading={isLoading}
      enableColumnActions={false}
      enableHiding={false}
      enableRowSelection
      enablePagination
      enablePinning
      pagination
      getRowId={(originalRow) => originalRow.id}
      // selectClicked={() => setHasSelected(tableRef?.getSelectedRowModel().rows.length > 0)}
    />;
  };

  return (
    <OffCanvas 
      showPanel={props.open}
      onClosedPanel={handleDrawerClose}
      isLoading={isLoading}
      buttons={buttons} 
      header={{ title: `Usuário - Clientes (${props.user.name})`, add: false, edit: true }}
    >
      <Grid container spacing={2} sx={(theme) => ({ mt: theme.spacing(2) })}>
        {customers &&
          <Grid size={12} sx={(theme) => ({ mb: theme.spacing(2) })}>
            { buildTable() }
          </Grid>
        }
      </Grid>
    </OffCanvas>
  );
};
